// Bilingual strings for the toddler app
export const t = (key, lang = "id") => {
  const dict = translations[key];
  if (!dict) return key;
  return dict[lang] || dict.id || key;
};

export const translations = {
  app_title: { id: "Petualangan Bayi", en: "Baby Adventures" },
  app_tagline: {
    id: "Bermain bersama teman kecilmu",
    en: "Play with your little friend",
  },
  pick_age: { id: "Pilih Usiamu", en: "Pick Your Age" },
  years: { id: "tahun", en: "years" },
  year: { id: "tahun", en: "year" },
  parent_corner: { id: "Pojok Orang Tua", en: "Parent Corner" },
  parent_gate_title: {
    id: "Khusus Orang Tua",
    en: "For Parents Only",
  },
  parent_gate_question: {
    id: "Berapa hasil 3 × 4?",
    en: "What is 3 × 4?",
  },
  parent_gate_hint: {
    id: "Ketuk jawaban yang benar",
    en: "Tap the correct answer",
  },
  wrong_try: { id: "Coba lagi ya!", en: "Try again!" },
  back: { id: "Kembali", en: "Back" },
  next_game: { id: "Permainan Lain", en: "Other Game" },
  great_job: { id: "Hebat!", en: "Great job!" },
  yay: { id: "Hore!", en: "Yay!" },
  again: { id: "Lagi", en: "Again" },
  // Layer themes
  layer_1: { id: "Kamar Bayi", en: "Nursery" },
  layer_2: { id: "Halaman", en: "Backyard" },
  layer_3: { id: "Taman Main", en: "Playground" },
  layer_4: { id: "Hutan Ajaib", en: "Magic Forest" },
  layer_5: { id: "Luar Angkasa", en: "Space" },
  // Companion names
  comp_1: { id: "Bayi Lulu", en: "Baby Lulu" },
  comp_2: { id: "Bayi Tata", en: "Baby Tata" },
  comp_3: { id: "Bayi Riri", en: "Baby Riri" },
  comp_4: { id: "Bayi Niko", en: "Baby Niko" },
  comp_5: { id: "Bayi Bintang", en: "Baby Star" },
  // Games L1
  g_peekaboo: { id: "Cilukba", en: "Peek-a-boo" },
  g_bubbles: { id: "Pecah Balon", en: "Pop Bubbles" },
  g_touch_sound: { id: "Sentuh & Bunyi", en: "Touch & Sound" },
  g_contrast: { id: "Pola Kontras", en: "Contrast Track" },
  g_drum: { id: "Kendang Kecil", en: "Baby Drum" },
  g_farmyard: { id: "Suara Hewan Lucu", en: "Animal Farmyard" },
  g_glow: { id: "Kunang-Kunang", en: "Catch Firefly" },
  g_falling: { id: "Tangkap Mainan", en: "Falling Toys" },
  g_emotions: { id: "Ekspresi Bintang", en: "Mascot Mimic" },
  g_silhouette: { id: "Cocok Bayangan", en: "Silhouette Match" },
  g_rattle: { id: "Kerincingan Bayi", en: "Baby Rattle" },
  g_sweeper: { id: "Pengusap Embun", en: "Fog Sweeper" },
  // Games L2
  g_animals: { id: "Suara Hewan", en: "Animal Sounds" },
  g_body: { id: "Bagian Tubuh", en: "Body Parts" },
  g_sort: { id: "Pilah Bentuk", en: "Sort Shapes" },
  g_mimicry: { id: "Tiru Emotikon", en: "Face Mimicry" },
  g_blow: { id: "Tiup Lilin", en: "Blow Candle" },
  g_toy_match: { id: "Bayangan Mainan", en: "Toy Shadow Match" },
  g_fruit_basket: { id: "Keranjang Buah", en: "Fruit Basket" },
  g_toy_phone: { id: "Telepon Mainan", en: "Toy Phone Call" },
  g_balloon_float: { id: "Balon Melayang", en: "Balloon Float" },
  g_hammering: { id: "Ketuk Palu", en: "Toy Hammering" },
  g_donut_stack: { id: "Susun Donut", en: "Donut Stacking" },
  g_sand_sweeper: { id: "Usap Pasir", en: "Sand Sweeper" },
  // Games L3
  g_match_color: { id: "Cocokkan Warna", en: "Match Colors" },
  g_puzzle: { id: "Puzzle Kecil", en: "Mini Puzzle" },
  g_feed: { id: "Suapi Bayi", en: "Feed the Baby" },
  g_tooth_match: { id: "Gigi Buaya", en: "Animal Tooth Match" },
  g_bubble_bath: { id: "Mandi Bebek", en: "Bubble Bath" },
  g_dress_up: { id: "Baju Bintang", en: "Dress Up Mascot" },
  g_bee_maze: { id: "Labirin Lebah", en: "Bee Path Finder" },
  g_angklung: { id: "Angklung Bambu", en: "Mini Angklung" },
  g_insect_finder: { id: "Kepik Daun", en: "Insect Finder" },
  g_rabbit_harvest: { id: "Wortel Kelinci", en: "Rabbit Harvest" },
  g_kendang: { id: "Tabuh Kendang", en: "Beat the Kendang" },
  g_paint_sweeper: { id: "Warna Pelangi", en: "Paint Sweeper" },
  // Games L4
  g_count: { id: "Hitung Apel", en: "Count Apples" },
  g_letters: { id: "Kenali Huruf", en: "Find Letters" },
  g_memory: { id: "Ingat Kartu", en: "Memory Match" },
  g_frog_hop: { id: "Lompat Katak", en: "Frog Hop Counting" },
  g_xylophone: { id: "Melodi Xilofon", en: "Rainbow Xylophone" },
  g_wheel_match: { id: "Roda Berputar", en: "Crazy Wheel Match" },
  g_ant_maze: { id: "Labirin Semut", en: "Ant Cookie Maze" },
  g_cloud_shape: { id: "Bentuk Awan", en: "Cloud Shadow Shape" },
  g_pizza_toppings: { id: "Pizza Toping", en: "Pizza Topping Match" },
  g_squirrel_tap: { id: "Ketok Tupai", en: "Whack-a-Squirrel" },
  g_farm_match: { id: "Suara Ternak", en: "Farmyard Sound Match" },
  g_window_sweeper: { id: "Usap Jendela", en: "Window Sweeper" },
  // Games L5
  g_words: { id: "Baca Kata", en: "Read Words" },
  g_math: { id: "Tambah Angka", en: "Add Numbers" },
  g_pattern: { id: "Lengkapi Pola", en: "Complete Pattern" },
  g_subtraction: { id: "Pecah Balon", en: "Balloon Subtraction" },
  g_spelling: { id: "Eja Hewan", en: "Animal Spelling" },
  g_double_gear: { id: "Gerigi Ganda", en: "Double Gear Rotation" },
  g_honey_maze: { id: "Sarang Madu", en: "Honeybee Maze" },
  g_tangram_match: { id: "Kapal Tangram", en: "Complex Tangram Match" },
  g_pizza_fraction: { id: "Pecahan Pizza", en: "Pizza Fraction Match" },
  g_mole_whack: { id: "Tikus Genap", en: "Fast Mole Whack" },
  g_angklung_melody: { id: "Melodi Angklung", en: "Angklung Melody Maker" },
  g_rainbow_paint: { id: "Cat Pelangi", en: "Rainbow Paint Sweeper" },
  // Misc
  tap_baby_hi: {
    id: "Halo! Ketuk aku!",
    en: "Hi! Tap me!",
  },
  baby_giggle: { id: "Hihihi!", en: "Hehehe!" },
  hide: { id: "Sembunyi", en: "Hiding" },
  found_me: { id: "Ketemu!", en: "Found me!" },
  pop_them: { id: "Pecahkan semua balon!", en: "Pop all the bubbles!" },
  what_sound: { id: "Suara apa ini?", en: "What sound is this?" },
  show_part: { id: "Tunjukkan: ", en: "Show: " },
  sort_to_box: { id: "Pasangkan bentuknya", en: "Match the shapes" },
  find_color: { id: "Temukan warna: ", en: "Find color: " },
  drag_pieces: { id: "Seret potongan ke tempatnya", en: "Drag pieces home" },
  give_food: { id: "Beri makan bayi", en: "Feed the baby" },
  count_total: { id: "Hitung apelnya!", en: "Count the apples!" },
  find_letter: { id: "Temukan huruf: ", en: "Find letter: " },
  match_pairs: { id: "Cocokkan kartu yang sama", en: "Match the pairs" },
  read_picture: { id: "Pilih kata yang sesuai gambar", en: "Pick the matching word" },
  what_is_sum: { id: "Berapa jumlahnya?", en: "What's the sum?" },
  complete_pattern: { id: "Apa selanjutnya?", en: "What comes next?" },
  // Parent dashboard
  pd_title: { id: "Pojok Orang Tua", en: "Parent Corner" },
  pd_settings: { id: "Pengaturan", en: "Settings" },
  pd_children: { id: "Anak", en: "Children" },
  pd_progress: { id: "Kemajuan", en: "Progress" },
  pd_add_child: { id: "Tambah Anak", en: "Add Child" },
  pd_name: { id: "Nama", en: "Name" },
  pd_age: { id: "Usia", en: "Age" },
  pd_save: { id: "Simpan", en: "Save" },
  pd_cancel: { id: "Batal", en: "Cancel" },
  pd_lang: { id: "Bahasa", en: "Language" },
  pd_sound: { id: "Efek Suara", en: "Sound Effects" },
  pd_music: { id: "Musik Latar", en: "Background Music" },
  pd_total_stars: { id: "Total Bintang", en: "Total Stars" },
  pd_plays: { id: "Bermain", en: "Plays" },
  pd_delete: { id: "Hapus", en: "Delete" },
  pd_no_children: {
    id: "Belum ada profil anak. Tambah anak untuk melacak kemajuan!",
    en: "No child profiles yet. Add a child to track progress!",
  },
  pd_select_child: { id: "Pilih anak untuk lihat kemajuan", en: "Select a child to view progress" },
  pd_layer: { id: "Tingkat", en: "Layer" },
  enter_name: { id: "Masukkan nama", en: "Enter name" },
  start_play: { id: "Mulai Main", en: "Start Play" },
};

export const useT = (lang) => (key) => t(key, lang);
